import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-16e2cf21"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modern-form-container" };
const _hoisted_2 = { class: "form-card" };
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "header-icon" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
    }, [
        /*#__PURE__*/ _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
        /*#__PURE__*/ _createElementVNode("circle", {
            cx: "12",
            cy: "7",
            r: "4"
        })
    ])
], -1));
const _hoisted_5 = { class: "form-title" };
const _hoisted_6 = { class: "form-subtitle" };
const _hoisted_7 = { class: "card-body" };
const _hoisted_8 = { class: "form-grid" };
const _hoisted_9 = { class: "input-group full-width" };
const _hoisted_10 = { class: "input-status confirmed" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("polyline", { points: "20,6 9,17 4,12" })
], -1));
const _hoisted_12 = { class: "input-group" };
const _hoisted_13 = { class: "input-group" };
const _hoisted_14 = {
    key: 0,
    class: "input-group"
};
const _hoisted_15 = { class: "password-strength" };
const _hoisted_16 = { class: "strength-text" };
const _hoisted_17 = {
    key: 1,
    class: "input-group"
};
const _hoisted_18 = {
    key: 0,
    class: "banner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_banner = _resolveComponent("hit-banner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.personal_information_form_personal_information')), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.personal_information_form_explanation_part_1')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_hit_form, {
                    name: "contactInformationForm",
                    value: _ctx.contactInformationData,
                    validations: _ctx.validations,
                    "force-cancel-button-hidden": true,
                    "force-save-button-hidden": true
                }, {
                    default: _withCtx(({ formData, validationState }) => [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_hit_input, {
                                    name: "email",
                                    class: "modern-input",
                                    value: _ctx.userRetrievedData.email,
                                    label: _ctx.t('admin-ui.email'),
                                    disabled: true
                                }, null, 8, ["value", "label"]),
                                _createElementVNode("div", _hoisted_10, [
                                    _hoisted_11,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.personal-email-confirmed')), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_hit_input, {
                                    name: "firstName",
                                    class: "modern-input",
                                    disabled: _ctx.userRetrievedData.first_name,
                                    value: formData.firstName,
                                    "validation-state": validationState.firstName,
                                    label: _ctx.t('admin-ui.first_name'),
                                    onInput: _ctx.onChangeFirstName
                                }, null, 8, ["disabled", "value", "validation-state", "label", "onInput"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_hit_input, {
                                    name: "lastName",
                                    class: "modern-input",
                                    disabled: _ctx.userRetrievedData.last_name,
                                    value: formData.lastName,
                                    "validation-state": validationState.lastName,
                                    label: _ctx.t('admin-ui.last_name'),
                                    onInput: _ctx.onChangeLastName
                                }, null, 8, ["disabled", "value", "validation-state", "label", "onInput"])
                            ]),
                            (!_ctx.userRetrievedData.hide_password)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createVNode(_component_hit_input, {
                                        name: "password",
                                        class: "modern-input",
                                        type: _ctx.inputPasswordType,
                                        "show-toggle-password": true,
                                        value: formData.password,
                                        "validation-state": validationState.password,
                                        label: _ctx.t('admin-ui.password'),
                                        "inline-input": "",
                                        onPasswordVisibilityChange: _ctx.switchPasswordVisibility,
                                        onInput: _ctx.onChangePassword
                                    }, null, 8, ["type", "value", "validation-state", "label", "onPasswordVisibilityChange", "onInput"]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["strength-bar", _ctx.getPasswordStrength(formData.password)])
                                        }, null, 2),
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getPasswordStrengthText(formData.password)), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.userRetrievedData.hide_password)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_component_hit_input, {
                                        name: "confirmPassword",
                                        class: "modern-input",
                                        type: _ctx.inputConfirmPasswordType,
                                        "show-toggle-password": true,
                                        value: formData.confirmPassword,
                                        label: _ctx.t('admin-ui.confirm_password'),
                                        "validation-state": validationState.confirmPassword,
                                        "inline-input": "",
                                        onInput: _ctx.onChangeConfirmPassword,
                                        onPasswordVisibilityChange: _ctx.switchConfirmPasswordVisibility
                                    }, null, 8, ["type", "value", "label", "validation-state", "onInput", "onPasswordVisibilityChange"])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _: 1
                }, 8, ["value", "validations"])
            ])
        ]),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_hit_banner, {
                    "show-animation": _ctx.showAnimationBanner,
                    onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.closeBanner()))
                }, {
                    "dynamic-content": _withCtx(() => [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.textBanner), 1)
                    ]),
                    _: 1
                }, 8, ["show-animation"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
